class PlugProductDetails extends HTMLElement {
  constructor() {
    super();
    this.tabs = [];
    this.panes = new Map();
  }

  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[data-plug-pd-tab]'));
    this.querySelectorAll('[data-plug-pd-pane]').forEach((pane) => {
      this.panes.set(pane.dataset.plugPdPane, pane);
    });

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', this.onTabClick.bind(this));
      tab.addEventListener('keydown', this.onTabKeydown.bind(this));
    });
  }

  onTabClick(event) {
    const target = event.currentTarget.dataset.plugPdTab;
    if (target) this.activate(target);
  }

  onTabKeydown(event) {
    if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
    event.preventDefault();
    const currentIndex = this.tabs.indexOf(event.currentTarget);
    if (currentIndex === -1) return;
    const delta = event.key === 'ArrowRight' ? 1 : -1;
    const nextIndex = (currentIndex + delta + this.tabs.length) % this.tabs.length;
    const nextTab = this.tabs[nextIndex];
    nextTab.focus();
    this.activate(nextTab.dataset.plugPdTab);
  }

  activate(target) {
    this.tabs.forEach((tab) => {
      const isActive = tab.dataset.plugPdTab === target;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });
    this.panes.forEach((pane, key) => {
      pane.classList.toggle('is-active', key === target);
    });
  }
}

if (!customElements.get('plug-product-details')) {
  customElements.define('plug-product-details', PlugProductDetails);
}
